module.exports = __webpack_public_path__ + "static/media/Screenshot_7.b8033268.png";